import React, { useEffect, useState } from "react";

import { Img, Text, Spinner } from "../../components";
import { useAppSelector, useAppDispatch } from "redux/hooks";
import {
  setPanfrontBinary,
  setCurrVerifyStep,
  setPanName,
} from "redux/features/CustomerRegistration/index";
import {
  POSTPanVerify,
  PostCustomerRegistrationStep2RequestType,
  PostCustomerRegistrationStep2FallbackReqType,
  POSTPanVerifyFallback,
} from "service/apis/CustomerRegistrationapi";
import { AxiosRequestConfig } from "axios";
import { toast } from "sonner";
import Panpopup from "models/Panpopup";
import FormPopup from "./PANandAadhaarPopup/formpopup";

type Step2Props = Partial<{
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
}>;

const Step2: React.FC<Step2Props> = ({ setCurrentStep }) => {
  const [file, setFile] = useState<File>();
  const [loading, setLoading] = useState<boolean>(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [type, setType] = useState("");
  const [showpanpopup, setShowpanpopup] = useState<boolean>(false);
  const [verifypandetails, setVerifypandetails] = useState<any>({
    masked_pan_no: "",
    name: "",
  });
  const dispatch = useAppDispatch();
  const PanNumber = useAppSelector(
    (state) => state.CustomerRegistration.PanNumber,
  );
  const Panfront = useAppSelector(
    (state) => state.CustomerRegistration.Panfront,
  );
  const PanfrontBinary = useAppSelector(
    (state) => state.CustomerRegistration.PanfrontBinary,
  );
  const customers_id = useAppSelector(
    (state) => state.CustomerRegistration.customers_id,
  );

  useEffect(() => {
    if (Panfront instanceof File) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (e.target?.result) {
          dispatch(setPanfrontBinary(e.target.result.toString()));
        }
      };
      reader.readAsDataURL(Panfront);
    }
  }, [Panfront]);

  const verifyPANFallback = async (data: { PAN: string; name: string }) => {
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);

    const req: AxiosRequestConfig<PostCustomerRegistrationStep2FallbackReqType> =
      {
        data: {
          customers_id,
          pan_no: data?.PAN,
          name: data?.name,
          pan_card: PanfrontBinary,
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
    setLoading(true);
    try {
      const response = await POSTPanVerifyFallback(req);
      if (response.status === 200) {
        setLoading(false);
        if (setCurrentStep) {
          dispatch(setCurrVerifyStep(2));
        }
        setDialogOpen(false);
        setCurrentStep?.((step) => step + 1);
      }
    } catch (error: any) {
      setLoading(false);
      toast.error(error?.response.data.message);
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setFile(file); // Update the file name state
      const reader = new FileReader();

      reader.onload = () => {
        const base64String = reader.result as string;
        dispatch(setPanfrontBinary(base64String));

        // Call API after file is converted to base64
        const auth: string | null = localStorage.getItem("authToken");
        if (auth === null) return;
        const authToken = JSON.parse(auth);

        if (!customers_id) return;

        const req: AxiosRequestConfig<PostCustomerRegistrationStep2RequestType> =
          {
            data: {
              pan_card: base64String,
              pan_no: PanNumber || "",
              customers_id: customers_id,
            },
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          };
        setLoading(true);

        POSTPanVerify(req)
          .then((res: any) => {
            setLoading(false);
            if (setCurrentStep) {
              dispatch(setCurrVerifyStep(2));
            }
            // Use result1.full_name for PAN name
            const panName = res.data?.result1?.full_name || res.data.full_name || "";
            setVerifypandetails({
              masked_pan_no: res.data.pan_no,
              name: panName,
            });
            // Store PAN name in Redux for name mismatch check
            dispatch(setPanName(panName));
            setShowpanpopup(true);
          })
          .catch((err) => {
            setLoading(false);
            if (
              err.response?.data?.message ===
              "Other customer is registered with this pan"
            ) {
              toast.error("Other customer is registered with this pan");
              return;
            }
            setType("PAN");
            setDialogOpen(true);
          });
      };

      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="flex gap-5">
      {loading && <Spinner />}
      <FormPopup
        defaultValue={PanNumber}
        entityType="customer"
        onSubmit={verifyPANFallback}
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        type={type}
      />
      {showpanpopup && setCurrentStep && (
        <div
          style={{ backgroundColor: "rgba(0, 0, 0, .6)" }}
          className="fixed top-0 left-0 z-[10] h-screen w-[100vw] flex justify-center items-center"
        >
          <Panpopup
            setCurrentStep={setCurrentStep}
            setShowpanpopup={setShowpanpopup}
            verifypandetails={verifypandetails}
          />
        </div>
      )}
      <div className="border-solid sm:pl-0 pl-10 flex md:flex-1 flex-col h-full  md:h-auto items-start justify-start  md:px-5 w-[53%] md:w-full">
        <div className="flex flex-col gap-8 items-start justify-start w-2/3 sm:w-full">
          <div className="flex relative flex-col gap-2.5 items-start justify-center w-full">
            <div
              className={`flex sm:hidden  items-center top-0 flex-col after:right-10 absolute ${false ? "after:h-0 " : "after:h-0"}  after:relative  after:content-[''] after:border after:border-dashed `}
            >
              <img
                className="relative -left-10 "
                src={`images/overview/ellipse.svg`}
                alt=""
              />
            </div>
            <Text className="text-sm font-medium leading-[17px]">
              Upload PAN card
            </Text>
            <div
              className={`py-1.5 px-3.5 justify-between rounded-md w-full border flex ${file?.name && "bg-[#F2F7FF]"}`}
            >
              <div className="flex gap-3 items-center overflow-hidden">
                <Img src="/images/remit/file.svg" alt="" />
                <p className="truncate">
                  {file?.name ? file?.name : "No file choosen"}
                </p>
              </div>
              <label
                htmlFor="fileupload3"
                className="text-blue-700 border border-blue-700 text-white ml-2 px-4 py-2 rounded-lg whitespace-nowrap"
              >
                {file?.name ? "Re-upload" : "Upload"}
              </label>
              <input
                name="fileupload3"
                type="file"
                id="fileupload3"
                className="hidden"
                onChange={handleFileChange}
                accept="image/*"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="border-solid flex sm:flex-1 flex-col md:h-auto md:hidden items-start justify-start md:px-5 sm:w-full">
        <div className="w-full flex flex-col gap-2">
          <h3 className="bg-[#F5F9FF] text-blue-700 py-3 px-4 rounded-md">
            Verify the details
          </h3>
          <div className="flex py-2 px-4 items-center gap-5">
            <Img src="/images/overview/exclamation.svg" />
            <p className=" text-sm text-black-label">
              PAN name is authorized as per document
            </p>
          </div>
          <div className="flex py-2 px-4 items-center gap-5">
            <Img src="/images/overview/exclamation.svg" />
            <p className=" text-sm text-black-label">
              Only the front of the Pan Card should be visible
            </p>
          </div>
          <div className="flex py-2 px-4 items-center gap-5">
            <Img src="/images/overview/exclamation.svg" />
            <p className=" text-sm text-black-label">
              The image uploaded is completely in the frame
            </p>
          </div>
          <div className="flex py-2 px-4 items-center gap-5">
            <Img src="/images/overview/exclamation.svg" />
            <p className=" text-sm text-black-label">
              Make sure that your details are clearly visible
            </p>
          </div>
        </div>
      </div>
      {/* </div>
      </div> */}
    </div>
  );
};

export default Step2;
